import React from 'react';

interface IProps {
  style?: any;
}

const BlackCheckIcon:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" style={props.style} fill="none" viewBox="0 0 23 23">
      <circle cx="11.5" cy="12" r="8" fill="#75D29A"/>
      <path fill="#122442" fillRule="evenodd" d="M15.805 10.303l-5.518 5.518-3.096-3.096 1.415-1.415 1.681 1.682 4.104-4.103 1.414 1.414z" clipRule="evenodd"/>
    </svg>
  )
}

export default BlackCheckIcon;